export default {
    DISPLAYED: 'displayed',
    DATE_RANGE: 'dateRange'
};
